export function addBreakpoint(element, breakpointFunc) {
  let action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'desktop';
  // Do nothing if the element is not found
  if (!element) return;

  // Make sure the action is a string or a function
  if (typeof action !== 'string' && typeof action !== 'function') return;

  // Create a new ResizeObserver
  const BreakpointObserver = new ResizeObserver(() => {
    // Test if the element is breaking
    let IS_BREAKING = false;
    if (breakpointFunc && typeof breakpointFunc === 'function') {
      IS_BREAKING = breakpointFunc();
    }
    if (typeof action === 'string') {
      // Toggle a class based on the overlap status
      return element.classList.toggle(action, !IS_BREAKING);
    }
    if (typeof action === 'function') {
      // Run a function based on the overlap status
      return action(IS_BREAKING);
    }
  });
  BreakpointObserver.observe(element);
}